import { ValueGetterParams } from "ag-grid-community";

import { getSplitSummary } from "selectors";

export function SplitValueGetter(props: ValueGetterParams) {
  const { data, colDef } = props;
  if (!data) {
    return null;
  }
  const value = data[colDef.field];

  if (!value) {
    return null;
  }

  return getSplitSummary(value);
}

export const BusinessDefaultVendorSplitGetter = (params: ValueGetterParams) => {
  const { data, context } = params;
  const { defaultVendorSplitByBusinessIdLookup } = context;

  if (!data || !defaultVendorSplitByBusinessIdLookup) {
    return "";
  }

  const { id: businessId } = data.business;
  const split = defaultVendorSplitByBusinessIdLookup[businessId];

  return getSplitSummary(split);
};

export const BusinessDefaultBuyerSplitGetter = (params: ValueGetterParams) => {
  const { data, context } = params;
  const { defaultBuyerSplitByBusinessIdLookup } = context;
  if (!data || !defaultBuyerSplitByBusinessIdLookup) {
    return "";
  }

  const { id: businessId } = data.business;
  const split = defaultBuyerSplitByBusinessIdLookup[businessId];

  return getSplitSummary(split);
};
